// extracted by mini-css-extract-plugin
export default {"address":"Address_address__R-jW4","name":"Address_name__KMwon","city":"Address_city__-jvq3"};